import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import backgroundImage from '../images/10246984.jpeg'

const ContactContainer = styled.div`
  background-image: url(${backgroundImage});
  background-size: cover;
  font-family: "Helvetica", sans-serif;
  background-position: center;
  background-attachment: fixed;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #ffffff;
`;

const ContentWrapper = styled.div`
  background-color: rgba(10, 25, 47, 0.8);
  padding: 2rem;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
`;

const Title = styled.h1`
  color: #dad7c9;
  text-align: center;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 0.5rem;
  border: 1px solid #e1ad21;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
`;

const TextArea = styled.textarea`
  padding: 0.5rem;
  border: 1px solid #e1ad21;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  min-height: 150px;
`;

const Button = styled.button`
  padding: 0.5rem 1rem;
  font-family: "Helvetica", sans-serif;
  background-color:#dad7c9;
  color: #0a192f;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;

  &:hover {
    background-color: #cec9ab;
  }
`;

const ContactInfo = styled.div`
  color: #dad7c9;
  margin-top: 2rem;
  text-align: center;
`;

function Contact() {
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (location.state && location.state.prefilledMessage) {
      setFormData(prevState => ({
        ...prevState,
        message: location.state.prefilledMessage
      }));
    }
  }, [location]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    formData.append("access_key", "605b86cb-6e5b-4414-b795-553f71366030");
    
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      
      if (data.success) {
        setStatus('Thank you for your message. We\'ll get back to you soon!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('Oops! There was a problem submitting your form. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('Oops! There was a problem submitting your form. Please try again.');
    }
  };

  return (
    <ContactContainer>
      <ContentWrapper>
        <Title>Contact Us</Title>
        
        <Form onSubmit={handleSubmit}>
          <input type="hidden" name="subject" value="New Contact Form Submission" />
          <input type="hidden" name="from_name" value="NueDesign Website" />
          <Input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            required
          />
          <Input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            required
          />
          <TextArea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your Message"
            required
          ></TextArea>
          <Button type="submit">Send Message</Button>
          {status && <p style={{ color: '#cec9ab', marginTop: '1rem' }}>{status}</p>}
        </Form>
        
        <ContactInfo>
          <h2>Get in Touch</h2>
          <p>Email: interiors@nuedesigns.com</p>
          <p>Phone: +(356) 99121636</p>          
        </ContactInfo>
      </ContentWrapper>
    </ContactContainer>
  );
}

export default Contact;
